<template>
    <div class="modal fade" id="setor_delete_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Deletar</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            Deseja realmente DELETAR o(a) <b>{{ delete_setor.nome }}</b>?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger"
                            @click.prevent.stop="deleteSetor">
                            Deletar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                delete_setor: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalDeleteSetor();
        },

        methods: {
            registryEventOpenModalDeleteSetor(){
                eventBus.$on('eventOpenModalDeleteSetor', (deleteSetor, currentPage) => {
                	this.errors = [];
                    this.delete_setor = Object.assign({}, deleteSetor);
                    this.currentPagePagination = currentPage;
                    $("#setor_delete_modal").modal("show");
                });
            },

            emitEventGetSetores(){
                eventBus.$emit('eventGetSetores', this.currentPagePagination);
            },

            deleteSetor()
            {
                this.isLoading = true;
                axios.delete(
                    '/setor/' + this.delete_setor.id
                )
                .then(response => {
                    this.isLoading = false;
                    $("#setor_delete_modal").modal("hide");
                    toastr.success(response.data.message);
                    this.emitEventGetSetores();
                })
                .catch(error => {
                    this.isLoading = false;
                    let erroObject = error.response.data;
                    if(erroObject.message)
                    {
                        toastr.error(erroObject.message);
                    }
                });
            }            
        }
    }
</script>